import * as React from "react";

import { cn } from "../../utils/cn";

type CustomProps = {
  slot1?: string;
};

export interface SlotProps extends React.HTMLProps<HTMLDivElement>, CustomProps {}

const Slot = React.forwardRef<HTMLDivElement, SlotProps>(
  ({ className, children, slot1, ...props }, ref) => {
    return (
      <div className={cn("", className)} ref={ref} {...props}>
        {children}
        {slot1}
      </div>
    );
  },
);
Slot.displayName = "Slot";

export { Slot };
